import React, { useState, useEffect } from "react";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";


import { Button, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { getPreviousDateAccToDays } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";
import StageHistoryModal from "./SendBackDetails/StageHistoryModal";
import ViewDetailsLink from "./SendBackDetails/ViewDetailsLink";
import { parseAndSetFlag } from "utils/Utils";

const Submitted = ({seletedBranchCode, featureFlags}) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [stageHistoryModal, setStageHistoryModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
    const enabledSendBackStageDetails = parseAndSetFlag(
    featureFlags?.enabledSendBackStageDetails
  );
  const [tableColumns, setTableColumns] = useState([
    { id: "applicationid", label: "Application ID"},
    { id: "created", label: "Created By" },
    { id: "formNumber", label: "Application Number" },
    { id: "accountNumber", label:"Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    { id: "customerName", label: "Customer Name" },
    { id: "productType", label: "Product Type" },
    { id: "type", label: "Application Type" },
    ...(enabledSendBackStageDetails
    ? [{ id: "stageHistory", label: "Stage History" }]
    : []),
    // { id: "action", label: "Action" },
  ]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const [totalCollateralValue,setTotalCollateralValue]=useState("")
  const [editableModal, setEditableModal] = useState(false);
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const [loanAccountNumber,setLoanAccountNumber] = useState("");
  const [status, setStatus] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [loanType, setLoanType]= useState("");
   const [fromDate,setFromDate] = useState(getApplicationFromDate());
  const [toDate,setToDate] = useState(new Date());
  const handleFromDateChange = (e) => {
    setFromDate(e)
  }
  const handleToDateChange = (e) => {
    setToDate(e)
  }
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress,
  } = useApplicantStatusData({
    status: "SANCTIONED,PRE_SANCTIONED,DEVIATION",
    fromDate,
    toDate,
    authToken,
    featureFlags,
  });
  const [subStatus,setSubStatus] =useState("")
  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else {
      parseIndicatorData(applicantData);
    }
  }, [applicantData, applicantDataError]);

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
    data &&
      data.forEach((SubmittedApplication, index) => {
        let row = {
          applicationid: SubmittedApplication.loanApplicationId,
          created: SubmittedApplication.createdBy,
          formNumber:SubmittedApplication.loanApplicationNumber,
          accountNumber:SubmittedApplication.loanAccountNumber,
          customerid:SubmittedApplication.customerId,
          customerName:SubmittedApplication.customerName,
          mobile:SubmittedApplication.mobileNumber?.trim(),
          type: `${removeUnderscores(SubmittedApplication?.applicationType)} / ${removeUnderscores(SubmittedApplication?.applicationSubType)}`,
          totalCollateralValue:SubmittedApplication?.totalCollateralValue,
          productType: SubmittedApplication?.productType,
          ...(enabledSendBackStageDetails
        ? {
            stageHistory: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {Number(
                  SubmittedApplication?.applicationStageHistoryCount
                ) > 0 && (
                  <ViewDetailsLink
                    onClick={() => {
                      setSelectedLeadId(
                        SubmittedApplication?.loanApplicationId
                      );
                      setStageHistoryModal(true);
                    }}
                  />
                )}
              </div>
            ),
          }
        : {}),
          // action:GetAction(
          //   SubmittedApplication.loanApplicationId,
          // ),
          };
        reportData.push(row);
      });

    setSelectedTableData(reportData);
  };
  const GetAction = (loanApplicationId) => {
    return (
      <>
        <Button
              // color="info"
          aria-label="Edit Branch"
          onClick={() => onClickUpdateData(loanApplicationId)}
        >
          Proceed
        </Button>
      </>
    );
  };
  const onClickUpdateData = async (
    loanApplicationId,
    loanAccountNo,
    totalCollateralValue,
    productType,
  ) => {
    const result = await apiHandler({
      url:
      endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}` ,
      authToken: authToken,
    });
      setLoanAPPLICATIONID(loanApplicationId);
      setStatus("SUBMITTED");
      setLoanAccountNumber(loanAccountNo);
      setTotalCollateralValue(totalCollateralValue);
      setSubStatus(result?.data?.applicationSubType ?result?.data?.applicationSubType :"")
      setLoanType(result?.data?.applicationType ? result?.data?.applicationType :"");
      const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
    const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]
        const navigationData = {
      loanApplicationId,
      loanAccountNo,
      status: 'SUBMITTED',
      subStatus: result?.data?.applicationSubType || "",
      prePledgeLoan: prepledgeLoanAccountNumber || "",
      editable: editableModal,
      loanType: result?.data?.applicationType || "",
      totalCollateralValue,
      seletedBranchCode,
      prepledgeLoanMap:prepledgeLoanMap,
      productType,
    };
      navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };
 

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Submitted Details"
          searchCriteria
          handleFromDateChange={handleFromDateChange}
          fromDate={fromDate}
          handleToDateChange={handleToDateChange}
          toDate={toDate}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} onClickUpdateData={onClickUpdateData} flag="submitted"/>
      </Grid>
      <StageHistoryModal
        open={stageHistoryModal}
        onClose={() => {
          setStageHistoryModal(false);
          setSelectedLeadId(null);
        }}
        leadId={selectedLeadId}
        authToken={authToken}
      />
    {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
          {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>




   
  );
};

Submitted.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
};

export default Submitted;
